"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveBrandTypographyConfig = void 0;
var typography_1 = require("../shared/typography");
var resolveBrandBodyFont_1 = require("./resolveBrandBodyFont");
function resolveBrandTypographyConfig(brand) {
    var fontFamily = (0, resolveBrandBodyFont_1.resolveBrandBodyFont)(brand);
    return __assign(__assign({ fontFamily: fontFamily, fontSize: 16 }, typography_1.disabledCoreVariants), { body1: { fontFamily: fontFamily } });
}
exports.resolveBrandTypographyConfig = resolveBrandTypographyConfig;
